module.exports = __webpack_public_path__ + "img/public/SiteIcons/nonRefund.svg?bd8e160c";